export default "__VITE_ASSET__CYVedSXN__"